import React from 'react';

const TermsOfService: React.FC = () => {
  return (
    <div className="pt-16 bg-white min-h-screen">
      {/* Page Title */}
      <div className="bg-white text-gray-800 py-12">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-[#2b603e] to-[#1a3d25]">Terms and Conditions</h1>
          <p className="text-xl max-w-3xl mx-auto text-gray-600">
            These Terms and Conditions govern the relationship between Asclepius Shilajit and our Customers.
          </p>
        </div>
      </div>

      {/* Divider */}
      <div className="container mx-auto px-4">
        <hr className="border-t border-gray-200 my-0" />
      </div>

      {/* Terms Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="space-y-8">
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 1 – Definitions</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li><strong>Company:</strong> Asclepius Shilajit, registered in Rotterdam, The Netherlands</li>
                <li><strong>Customer:</strong> The natural or legal person who places an order with the Company</li>
                <li><strong>Product:</strong> All dietary supplements and related goods offered by the Company</li>
                <li><strong>Agreement:</strong> The purchase agreement between the Company and the Customer</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 2 – Applicability</h2>
              <p className="text-gray-600 mb-4">
                <strong>2.1 </strong> These Terms and Conditions apply to all offers, orders, and agreements concluded between the Company and the Customer, unless explicitly agreed otherwise in writing.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>2.2 </strong> Deviations from these Terms and Conditions are only valid if expressly agreed in writing.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>2.3 </strong> If any provision is invalid or unenforceable, the remainder of the Terms remain fully applicable.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 3 – Offers and Conclusion of Agreement</h2>
              <p className="text-gray-600 mb-4">
                <strong>3.1 </strong> All offers made by the Company are non-binding and subject to availability.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>3.2 </strong> The Agreement is concluded at the moment the Company confirms the order or begins processing it.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>3.3 </strong> The Company reserves the right to refuse orders without giving reasons.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 4 – Prices and Payment</h2>
              <p className="text-gray-600 mb-4">
                <strong>4.1 </strong> All prices on the website are in Euros (€), including applicable VAT and other taxes, unless stated otherwise.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>4.2 </strong> The Company reserves the right to change prices at any time without prior notice.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>4.3 </strong> Payment must be made in full prior to delivery using the payment methods offered by the Company’s payment provider, including but not limited to: iDEAL, credit card, PayPal, and bank transfer.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>4.4 </strong> The Customer guarantees that the payment details provided are accurate and authorized.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>4.5 </strong> If payment is not received within the agreed timeframe, the Company reserves the right to cancel the order without liability.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>4.6 </strong> The Products are classified as dietary supplements. The Company applies the applicable VAT rate based on the current classification of the Product under Dutch tax law. At this time, the standard VAT rate of 21% applies unless an official reduced rate (such as 9%) is confirmed by the Dutch Tax Authorities.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>4.7 </strong> Import duties, VAT, and other taxes related to delivery outside the Netherlands may be charged to the Customer separately and will be communicated before finalizing the order.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 5 – Delivery and Risk</h2>
              <p className="text-gray-600 mb-4">
                <strong>5.1 </strong> The Company will deliver the Products to the delivery address provided by the Customer.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>5.2 </strong> Delivery times stated are indicative and not guaranteed. Delays do not entitle the Customer to compensation or cancellation unless explicitly agreed.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>5.3 </strong> Risk passes to the Customer upon delivery or at the moment the Product is made available to the Customer or a carrier appointed by them.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 6 – Right of Withdrawal and Returns</h2>
              <p className="text-gray-600 mb-4">
                <strong>6.1 </strong> The Customer has the right to withdraw from the Agreement within 14 days after receipt of the Product, without giving reasons.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>6.2 </strong> To exercise this right, the Customer must notify the Company in writing before the deadline expires.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>6.3 </strong> Returned Products must be unopened, unused, and in their original packaging. Products that have been opened or used cannot be returned due to hygiene reasons.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>6.4 </strong> The Customer bears the costs of return shipment unless the return is due to Company error or a defective Product.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>6.5 </strong> Refunds will be processed within 14 days after the Company receives the returned Product and verifies its condition.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>6.6 </strong> The Company may withhold the refund until the returned Products have been received and inspected.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 7 – Warranty and Liability</h2>
              <p className="text-gray-600 mb-4">
                <strong>7.1 </strong> The Company guarantees that the Products comply with applicable Dutch food and supplement laws and regulations.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>7.2 </strong> The Products are dietary supplements and are not intended to diagnose, treat, cure, or prevent any disease. The Company does not make medical claims beyond what is legally allowed.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>7.3 </strong> The Company does not guarantee specific health results; effects may vary per individual.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>7.4 </strong> The Company’s liability is limited to direct damages caused by gross negligence or intent and never exceeds the purchase price of the Products involved.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>7.5 </strong> The Company excludes liability for indirect damages, including lost profit, missed savings, or consequential damages.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 8 – Intellectual Property</h2>
              <p className="text-gray-600 mb-4">
                <strong>8.1 </strong> All intellectual property rights on the Company’s website, including texts, images, logos, and designs, belong to the Company or its licensors.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>8.2 </strong> Unauthorized use, copying, or distribution is prohibited and may result in legal action.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 9 – Privacy and Data Protection</h2>
              <p className="text-gray-600 mb-4">
                <strong>9.1 </strong> The Company processes personal data according to the Privacy Policy, available on the website.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>9.2 </strong> By placing an order, the Customer consents to the processing of their personal data for order fulfillment and communication.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>9.3 </strong> The Company takes appropriate measures to protect personal data in compliance with the General Data Protection Regulation (GDPR).
              </p>
              <p className="text-gray-600 mb-4">
                <strong>9.4 </strong> Customers have the right to access, correct, or delete their personal data, and to withdraw consent at any time as described in the Privacy Policy.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 10 – Force Majeure</h2>
              <p className="text-gray-600 mb-4">
                <strong>10.1 </strong> The Company is not liable for failure to fulfill obligations due to circumstances beyond its control, including but not limited to strikes, natural disasters, government measures, or supplier failures.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>10.2 </strong> In such cases, the Company may suspend delivery or cancel the Agreement without liability.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 11 – Applicable Law and Dispute Resolution</h2>
              <p className="text-gray-600 mb-4">
                <strong>11.1 </strong> These Terms and Conditions are governed exclusively by Dutch law.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>11.2 </strong> All disputes arising from or related to the Agreement will be submitted exclusively to the competent court in Rotterdam.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 12 – Final Provisions</h2>
              <p className="text-gray-600 mb-4">
                <strong>12.1 </strong> If any provision of these Terms is void or unenforceable, the remaining provisions remain fully in effect.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>12.2 </strong> The Company reserves the right to amend these Terms at any time. The most current version is always published on the website.
              </p>
              <p className="text-gray-600 mb-4">
                <strong>12.3 </strong> By placing an order, the Customer accepts any amendments to these Terms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Article 13 – Company Information and Contact</h2>
              <p className="text-gray-600 mb-4"><strong>13.1 </strong> Company name: Asclepius Shilajit</p>
              <p className="text-gray-600 mb-4"><strong>13.2 </strong> Registered office: Rotterdam, The Netherlands</p>
              <p className="text-gray-600 mb-4"><strong>13.3 </strong> Chamber of Commerce (KvK) number: 97472875</p>
              <p className="text-gray-600 mb-4"><strong>13.4 </strong> Email: info@asclepius-shilajit.com</p>
              <p className="text-gray-600 mb-4"><strong>13.5 </strong> Telephone: +31 6 57945978</p>
              <p className="text-gray-600 mb-4"><strong>13.6 </strong> Customer service is available Monday to Friday, 09:00–17:00</p>
              <p className="text-gray-600 mb-4">
                <strong>13.7 </strong> Customers can contact the Company for questions, complaints, or any other communication regarding Products or Orders using the contact details above.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact Information</h2>
              <p className="text-gray-600">
                <strong>Company:</strong> Asclepius Shilajit<br />
                <strong>Location:</strong> Rotterdam, The Netherlands<br />
                <strong>Customer Service Hours:</strong> Monday to Friday, 09:00–17:00
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService; 